import React from "react";
import { HelpCircle, Mail, MessageCircle, ExternalLink } from "lucide-react";

export default function LandlordSupport() {
  return (
    <div className="space-y-6" data-testid="landlord-support">
      <div>
        <h1 className="text-3xl font-bold font-display">Support</h1>
        <p className="text-sm text-gray-500 mt-1">Get help and reach our support team.</p>
      </div>

      {/* Support Channels */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Email */}
        <div className="card-base p-6">
          <div className="flex items-start gap-4">
            <div className="h-10 w-10 rounded-lg bg-[#FFF4ED] text-[#F97316] flex items-center justify-center flex-shrink-0">
              <Mail className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold mb-1">Email Support</h3>
              <p className="text-sm text-gray-600 mb-4">Reach us via email for detailed inquiries.</p>
              <a
                href="mailto:support@orello.com"
                className="text-[#F97316] hover:underline text-sm font-medium flex items-center gap-1"
              >
                support@orello.com
                <ExternalLink className="h-3 w-3" />
              </a>
            </div>
          </div>
        </div>

        {/* WhatsApp */}
        <div className="card-base p-6">
          <div className="flex items-start gap-4">
            <div className="h-10 w-10 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
              <MessageCircle className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold mb-1">WhatsApp Support</h3>
              <p className="text-sm text-gray-600 mb-4">Chat with us on WhatsApp for quick help.</p>
              <a
                href="https://wa.me/919876543210"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#F97316] hover:underline text-sm font-medium flex items-center gap-1"
              >
                Chat on WhatsApp
                <ExternalLink className="h-3 w-3" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="card-base p-6">
        <div className="flex items-center gap-2 mb-4">
          <HelpCircle className="h-5 w-5 text-[#F97316]" />
          <h3 className="font-semibold">Frequently Asked Questions</h3>
        </div>
        <div className="space-y-4">
          <details className="border-b border-gray-100 pb-4 last:border-0">
            <summary className="font-medium text-gray-900 cursor-pointer hover:text-[#F97316] transition-colors">
              How do I create a new agreement?
            </summary>
            <p className="text-sm text-gray-600 mt-2">
              Click on "New Agreement" button in the left sidebar to create a new rental agreement with a tenant.
            </p>
          </details>

          <details className="border-b border-gray-100 pb-4 last:border-0">
            <summary className="font-medium text-gray-900 cursor-pointer hover:text-[#F97316] transition-colors">
              When will my deposit be released?
            </summary>
            <p className="text-sm text-gray-600 mt-2">
              Deposits are typically released within 7-10 business days after the checkout report is completed and verified.
            </p>
          </details>

          <details className="border-b border-gray-100 pb-4 last:border-0">
            <summary className="font-medium text-gray-900 cursor-pointer hover:text-[#F97316] transition-colors">
              How do I dispute a deposit release?
            </summary>
            <p className="text-sm text-gray-600 mt-2">
              You can raise a dispute from the deposit details page if you believe the tenant caused damage that warrants deductions.
            </p>
          </details>
        </div>
      </div>
    </div>
  );
}
